<div class="hostInfo">
    <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-12">
            <h2 style="text-align: center; font-size: 24px; margin-bottom: 10px; color: #9e3249;">Host Information</h2>
            <div class="row">
                <div class="col-sm-12 col-md-6 col-lg-6">
                    Name : <span class="contentCls"> {{host?.firstName}} {{host?.lastName}}</span>
                </div>
                <div class="col-sm-12 col-md-6 col-lg-6">
                    Email : <span class="contentCls"> {{host?.email}} </span>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 col-md-12 col-lg-12">
                    Phone : <span class="contentCls"> {{host?.phone}}</span>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 col-md-12 col-lg-12">
                    Explanation : <span class="contentCls"> {{host?.whyStrongSeller}}</span>
                </div>
            </div>
            <br>

            <div class="row">
                <div class="col-sm-12 col-md-6 col-lg-6">
                    Bussiness Name : <span class="contentCls"> {{host?.interestedHostDetails[0].businessName}}</span>
                </div>
                <div class="col-sm-12 col-md-6 col-lg-6">
                    Bussiness DBA : <span class="contentCls"> {{host?.interestedHostDetails[0].businessDba}}</span>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 col-md-6 col-lg-6">
                    Bussiness Address : <span class="contentCls"> {{host?.interestedHostDetails[0].businessAddress}}</span>
                </div>
                <div class="col-sm-12 col-md-6 col-lg-6">
                    Bussiness Phone : <span class="contentCls"> {{host?.interestedHostDetails[0].businessPhoneNumber}}</span>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 col-md-12 col-lg-12">
                    Company Name : <span class="contentCls"> {{host?.interestedHostDetails[0].companyName}}</span>
                </div>
                
            </div>
            <br>

            <!-- <div class="row">
                <div class="col-sm-12 col-md-12 col-lg-12">
                    How Currently Selling To Customer : <span class="contentCls"> {{host?.phone}}</span>
                </div>
            </div> -->
            <div class="row">
                <div class="col-sm-12 col-md-12 col-lg-12">
                    Years In Bussiness : <span class="contentCls"> {{host.interestedHostDetails[0].yearsInBusiness?.name}}</span>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 col-md-6 col-lg-6">
                    Online Rating Company : <span class="contentCls"> {{host.interestedHostDetails[0].onlineRatingCompany?.name}}</span>
                </div>
                <div class="col-sm-12 col-md-6 col-lg-6">
                    Online Rating Score : <span class="contentCls"> {{host.interestedHostDetails[0]?.onlineRatingScore}}</span>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 col-md-6 col-lg-6">
                    Primary Item Of Sale : <span class="contentCls"> {{host.interestedHostDetails[0].primaryItems?.name}}</span>
                </div>
                <div class="col-sm-12 col-md-6 col-lg-6">
                    Secondary Item Of Sale : <span class="contentCls"> {{host.interestedHostDetails[0].secondayItem?.name}}</span>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 col-md-6 col-lg-6">
                    Expected Subscribers : <span class="contentCls"> {{host.interestedHostDetails[0].howManySubscribers?.name}}</span>
                </div>
                <div class="col-sm-12 col-md-6 col-lg-6">
                    SSN : <span class="contentCls"> {{host.interestedHostDetails[0]?.ssn}}</span>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 col-md-6 col-lg-6">
                    Preferred Room Name : <span class="contentCls"> {{host.interestedHostDetails[0]?.prefferedRoomName}}</span>
                </div>
                <div class="col-sm-12 col-md-6 col-lg-6">
                    Tax ID : <span class="contentCls"> {{host.interestedHostDetails[0]?.taxId}}</span>
                </div>
            </div>
            <br>

            <div class="row">
                <div class="col-sm-12 col-md-12 col-lg-12" style="font-size: 18px !important;">
                    <mat-checkbox [checked]="host.consent" disabled></mat-checkbox> I consent to be contacted by an onboarding specialist. <br>
                    <mat-checkbox [checked]="host.interestedHostDetails[0]?.termAndCondition" disabled></mat-checkbox> I agree to the Hosting Terms and Conditions. <br>
                    <mat-checkbox [checked]="host.interestedHostDetails[0]?.paymentPolicy" disabled></mat-checkbox> I agree to the Payment Policy <br>
                    <mat-checkbox [checked]="host.interestedHostDetails[0]?.resolutionAndDisputePolicy" disabled></mat-checkbox> I agree to the Resolution and Dispute Policy. <br>
                    <mat-checkbox [checked]="host.interestedHostDetails[0]?.shippingPolicy" disabled></mat-checkbox>  I agree to the Shipping Policy. <br>
                </div>
            </div>
        </div>
    </div>
</div>